import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { useLookup, LookupBar, BookingCard, CancelForm, CancelReceipt } from "@/pages/admin/TicketDesk";
import CancellationHistory from "@/components/CancellationHistory";

const TELLER_REASONS = [
  ["teller_mistake", "My mistake", "0% - full refund, allowed within the time limit for tickets you sold."],
  ["customer_request", "Customer request", "10% if 12h+ before departure, 20% at 6-12h, 50% under 6h."],
  ["no_show", "No show", "100% charge - passenger did not turn up at departure."],
  ["trip_not_performed", "Trip not performed", "0% - bus did not run, 100% returned. Needs admin approval."],
];

export default function TellerCancellations() {
  const l = useLookup();
  return (
    <div className="space-y-4" data-testid="teller-cancellations">
      <h2 className="font-display text-2xl font-extrabold tracking-tight">Cancellations</h2>
      <Tabs defaultValue="cancel">
        <TabsList className="rounded-xl">
          <TabsTrigger value="cancel" data-testid="teller-cancel-tab">Ticket cancellation</TabsTrigger>
          <TabsTrigger value="history" data-testid="teller-cancel-history-tab">History</TabsTrigger>
        </TabsList>
        <TabsContent value="cancel" className="space-y-4">
          <p className="text-sm text-slate-500">Enter a ticket number to view the ticket and its cancellation modes. "My mistake" is allowed within the time limit for tickets you sold; other reasons apply the cancellation policy.</p>
          <LookupBar l={l} testid="teller-cancel" />
          {l.b && <BookingCard b={l.b} />}
          {l.b && ["confirmed", "reserved"].includes(l.b.status) && <CancelForm b={l.b} reasons={TELLER_REASONS} onDone={(d) => l.setB(d)} />}
          {l.b?.status === "cancelled" && <CancelReceipt booking={l.b} />}
        </TabsContent>
        <TabsContent value="history"><CancellationHistory showCancelledBy={false} /></TabsContent>
      </Tabs>
    </div>
  );
}
